// Action SuperAdmin : liste des produits canoniques de TOUS les comptes.
//
// L'appel passe par le relais Express /stocks/superadmin/products, jamais
// directement par le storehouse : le relais transmet l'identité de
// l'utilisateur connecté, et le storehouse vérifie lui-même auprès de
// domainModel que cet utilisateur est SuperAdmin.

// Messages de repli, employés quand le serveur ne fournit pas le sien. Les
// deux refus attendus : 401 pour un jeton invalide ou expiré, 403 pour un
// utilisateur qui n'est pas SuperAdmin.
const DEFAULT_MESSAGES = {
    401: "Session expirée ou invalide : merci de vous reconnecter.",
    403: "Accès refusé : cet écran est réservé aux SuperAdmin.",
}

function errorMessage(status, body) {
    if (body && body.error && body.error.message) {
        return body.error.message
    }
    if (DEFAULT_MESSAGES[status]) {
        return DEFAULT_MESSAGES[status]
    }
    return "Impossible de charger les produits (erreur " + status + ")."
}

/**
 * Supprime physiquement une fiche produit (SuperAdmin uniquement).
 *
 * Le storehouse refuse (409) toute fiche encore utilisée ailleurs : fusionnée,
 * canonique d'autres fiches, réglée ou rattachée par un autre compte, ou avec
 * un historique de stock. Son message est relayé tel quel dans l'erreur levée.
 * En cas de succès, la ligne est retirée de la liste.
 */
export function deleteSuperAdminProduct(produit) {
    return async function (dispatch) {
        const response = await fetch('/stocks/superadmin/products', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: produit.id }),
            credentials: 'same-origin',
        })

        // fetch ne rejette pas sur un statut d'erreur, et le 403 sans corps
        // n'est pas du JSON.
        let body = null
        try {
            body = await response.json()
        } catch (parseError) {
            body = null
        }

        if (response.ok && body === "OK") {
            dispatch({
                type: "DELETE_SUPERADMIN_PRODUCT",
                payload: produit.id,
            })
            return "OK"
        }

        const message = (body && body.error && body.error.message)
            || DEFAULT_MESSAGES[response.status]
            || "Suppression impossible (erreur " + response.status + ")."
        throw new Error(message)
    }
}

/**
 * Charge les produits canoniques tous comptes confondus.
 * @param {boolean} includeStock demande les quantites en stock (couteux cote
 *        storehouse) : jamais actif au premier rendu.
 */
export function fetchSuperAdminProducts(includeStock = false) {
    return async function (dispatch) {
        dispatch({
            type: "FETCH_SUPERADMIN_PRODUCTS_START",
            payload: ""
        })

        try {
            const url = includeStock
                ? '/stocks/superadmin/products?include_stock=true'
                : '/stocks/superadmin/products'

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            })

            // Le 403 sans corps (utilisateur non authentifie) n'est pas du JSON.
            let body = {}
            try {
                body = await response.json()
            } catch (parseError) {
                body = {}
            }

            if (!response.ok || (body && body.error)) {
                dispatch({
                    type: "FETCH_SUPERADMIN_PRODUCTS_ERROR",
                    payload: errorMessage(response.status, body),
                })
                return
            }

            dispatch({
                type: "FETCH_SUPERADMIN_PRODUCTS_FULFILLED",
                payload: {
                    produits: Array.isArray(body.produits) ? body.produits : [],
                    totaux: body.totaux || {},
                    withStock: includeStock,
                },
            })

        } catch (err) {
            console.log("[ERROR] fetchSuperAdminProducts ", err)
            dispatch({
                type: "FETCH_SUPERADMIN_PRODUCTS_ERROR",
                payload: "Impossible de joindre le serveur.",
            })
        }
    }
}
